import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemId, User } from '../../../types/items';
import { ItemList, ListParams } from '../../../types/main';

export const getCurrentUserRequest = action('GET_CURRENT_USER_REQUEST', withoutPayload);
export const getCurrentUserSuccess = action('GET_CURRENT_USER_SUCCESS', withPayload<User>());
export const getCurrentUserFail = action('GET_CURRENT_USER_FAIL', withoutPayload);

export const initUserRequest = action('INIT_USER_REQUEST', withoutPayload);
export const initUserSuccess = action('INIT_USER_SUCCESS', withPayload<User>());
export const initUserFail = action('INIT_USER_FAIL', withoutPayload);

export const createUserRequest = action('CREATE_USER_REQUEST', withPayload<User>());
export const createUserSuccess = action('CREATE_USER_SUCCESS', withPayload<User>());
export const createUserFail = action('CREATE_USER_FAIL', withoutPayload);

export const getUserListRequest = action('GET_USER_LIST_REQUEST', withPayload<ListParams>());
export const getUserListSuccess = action('GET_USER_LIST_SUCCESS', withPayload<ItemList<User>>());
export const getUserListFail = action('GET_USER_LIST_FAIL', withoutPayload);

export const getUserRequest = action('GET_USER_REQUEST', withPayload<ItemId>());
export const getUserSuccess = action('GET_USER_SUCCESS', withPayload<User>());
export const getUserFail = action('GET_USER_FAIL', withoutPayload);

export const saveUserRequest = action('SAVE_USER_REQUEST', withPayload<User>());
export const saveUserSuccess = action('SAVE_USER_SUCCESS', withPayload<User>());
export const saveUserFail = action('SAVE_USER_FAIL', withoutPayload);

export const saveCurrentUserRequest = action(
  'SAVE_CURRENT_USER_REQUEST',
  withPayload<User>(),
);
export const saveCurrentUserSuccess = action(
  'SAVE_CURRENT_USER_SUCCESS',
  withPayload<User>(),
);
export const saveCurrentUserFail = action(
  'SAVE_CURRENT_USER_FAIL',
  withoutPayload,
);

export const clearUserState = action(
  'CLEAR_USER_STATE',
  withoutPayload,
);
